var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconTime(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.98395V7.17735L8.75 8.8224M12.25 7.17735C12.25 7.82544 12.1142 8.46719 11.8504 9.06596C11.5865 9.66472 11.1998 10.2088 10.7123 10.667C10.2248 11.1253 9.64605 11.4888 9.00909 11.7369C8.37213 11.9849 7.68944 12.1125 7 12.1125C6.31056 12.1125 5.62787 11.9849 4.99091 11.7369C4.35395 11.4888 3.7752 11.1253 3.28769 10.667C2.80018 10.2088 2.41347 9.66472 2.14963 9.06596C1.8858 8.46719 1.75 7.82544 1.75 7.17735C1.75 5.86846 2.30312 4.61319 3.28769 3.68766C4.27226 2.76214 5.60761 2.24219 7 2.24219C8.39239 2.24219 9.72774 2.76214 10.7123 3.68766C11.6969 4.61319 12.25 5.86846 12.25 7.17735Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconTime);
export default __webpack_public_path__ + "static/media/common_icon_time.a1bb776a84081e8b4f2f5f0bd121697f.svg";
export { ForwardRef as ReactComponent };